<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h4>Veranstaltung </h4>
        </div>
    </div>

    <div class="row " [formGroup]="filterForm">
        <div class="col-sm-3">
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Suche</mat-label>
                <input type="email" matInput formControlName="searchTerm" placeholder="suchen.." (keydown)="onKeydown($event)">
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Status</mat-label>
                <mat-select formControlName="filterByStates" multiple="true">
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByStates.value != null ">
                            {{this.filterForm.controls.filterByStates.value | translateNewsFilter : 'filterByStates'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterByStates.value?.length > 1"
                            >
                            (+{{this.filterForm.controls.filterByStates.value.length - 1 }}
                            {{this.filterForm.controls.filterByStates.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of states"  [value]="sortOption.value">
                        {{sortOption.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Typ</mat-label>
                <mat-select formControlName="filterByTypes" multiple="true">
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByTypes.value != null ">
                            {{this.filterForm.controls.filterByTypes.value | translateNewsFilter : 'filterByTypes'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterByTypes.value?.length > 1"
                            >
                            (+{{this.filterForm.controls.filterByTypes.value.length - 1 }}
                            {{this.filterForm.controls.filterByTypes.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>

                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of types" [value]="sortOption.value">
                        {{sortOption.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>

        </div> -->



        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Sichtbarkeit</mat-label>
                <mat-select formControlName="filterByVisibility" multiple="true">
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByVisibility.value != null ">
                            {{this.filterForm.controls.filterByVisibility.value | translateNewsFilter : 'filterByVisibility'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterByVisibility.value?.length > 1"
                            >
                            (+{{this.filterForm.controls.filterByVisibility.value.length - 1 }}
                            {{this.filterForm.controls.filterByVisibility.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of visibility"  [value]="sortOption.value">
                        {{sortOption.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>


    </div>
    <div class="col-sm-12 marginBottom2Rem">
        <button mat-button mat-raised-button color="accent" (click)="filterNews()" >
            Anwenden
        </button>

        <button mat-button mat-raised-button color="primary" (click)="resetFitler()" style="margin-left: 15px;"
            [disabled]="!this.filterForm.touched">
            Filter zurücksetzen
        </button>
    </div>


    <div class="row">
        <div class="col-sm-12">
            <div class="example-container mat-elevation-z2">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
                            {{i+1}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="image">
                        <th mat-header-cell *matHeaderCellDef>
                            Bild
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            <img src="{{element?.image?.href}}" *ngIf="element?.image?.href" style="width: 100%;" alt="">
                            <img src="{{element?.feedSource?.defaultImage.url}}"  *ngIf="!element?.image?.href" style="width: 100%;" alt="">
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef>
                            Titel
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element?.title}}
                        </td>
                    </ng-container>



                    <ng-container matColumnDef="source">
                        <th mat-header-cell *matHeaderCellDef>
                            Quelle
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column w20">
                            {{element?.feedSource?.feedUri}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>
                            Datum
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element?.appointmentTime }}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            <mat-chip-set>
                                <mat-chip class="primaryChip" selected>
                                    {{element?.state | translateState}}
                                </mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="state">
                        <th mat-header-cell *matHeaderCellDef>
                            Typ
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            <mat-chip-set>
                                <mat-chip class="primaryChip" selected>
                                    {{element?.type | translateState}}
                                </mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>



                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktion
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                color="accent" >
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item [routerLink]="['edit', element.publicId]">
                                    <span>Bearbeiten</span>
                                </button>
                                <button mat-menu-item (click)="setStateToARCHIVED(element)" >
                                    <span>Archivieren</span>
                                </button>
                                <button mat-menu-item (click)="setStateToPublished(element)" [disabled]="element.state ==  'PUBLISHED'" >
                                    <span>Freischalten</span>
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                </table>

                <span *ngIf="dataSource?.data.length === 0" class="emptyTableState">Keine passenden Einträge
                    gefunden</span>


            </div>
            <button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['add']">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <mat-paginator [length]="page.totalElements" class="paginator-centered" [pageSize]="page.size"
                [pageIndex]="page.number" (page)="loadPage($event)" [pageSizeOptions]="[6, 12, 24, 36]" *ngIf="page">
            </mat-paginator>
        </div>
    </div>
</div>